// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentEscalationProcessListController = function ($scope, $location, PaymentEscalationProcess) {
    $scope.processes = PaymentEscalationProcess.query(function () {
        var id = $scope.processes.length > 0 ? $scope.processes[0].Id : "create/";
        $location.path("/settings/payment-escalation/" + id);
    });
};
PaymentEscalationProcessListController.$inject = ['$scope', '$location', 'PaymentEscalationProcess'];
